import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    title: {
        paddingTop: theme.spacing(6),
        paddingBottom: theme.spacing(6),
        marginBottom: theme.spacing(1),
        fontSize: 28,
        color: 'white',
        backgroundColor: theme.palette.primary.main,
        width: '100%'
    },
    question: {
        width: '80%',
        '& .MuiTypography-root': {
            width: '100%',
            fontSize: 24,
            marginBottom: theme.spacing(1)
        },
        '& .MuiFormControl-root': {
            width: '100%',
        },
        '& .MuiInputBase-root': {
            width: '100%',
            fontSize: 20
        },
        marginBottom: theme.spacing(2)
    }
}));

export default useStyles;